<template>
  <div class="setAmountExams">
    <h2 class="setAmountExams__title">Quantos exames ou vacinas você vai fazer hoje?</h2>
    <div class="setAmountExams__buttons">
      <VButton text="2 ou menos" variant="secondary" @click.native="setTwoOrLessExams()" />
      <VButton text="3 ou mais" variant="secondary" @click.native="setThreeOrMoreExams()" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  mixins: [dataLayersMixin],
  mounted() {
    this.mostCommonPagesAnalytics({
      step: 'seleção_de_serviços',
      screen: 'seleção_quantidade_serviços',
      complementaryObject: {
        previous_choice: 'Não vou usar convênio',
      },
      payment: {
        type: 'particular',
      },
    });
  },
  methods: {
    ...mapActions({
      setAdmissionNotElegible: 'setAdmissionNotElegible',
    }),
    async setTwoOrLessExams() {
      return this.goNextStep('advantages_checkin');
    },
    async setThreeOrMoreExams() {
      await this.setAdmissionNotElegible();
      return this.goNextStep('exams_add', { previous_choice: '3 ou mais' });
    },
  },
};
</script>

<style lang="scss" scoped>
.setAmountExams {
  &__title {
    color: #6e7788;
    margin-top: 56px;
    margin-bottom: 24px;
  }

  &__buttons {
    width: 100%;
    max-width: 264px;
    margin: 0 auto;
    button {
      margin-bottom: 16px;
    }
  }
}
</style>
